<div class="drawer" [class.portfolio-action-drawer]="showAtTop"><ng-content></ng-content></div>
